import { jsx as _jsx } from "react/jsx-runtime";
import { HostContext } from './context';
export function HostProvider({ children, ...props }) {
    return _jsx(HostContext.Provider, { value: props, children: children });
}
